
import React from 'react';
import { FacilityOrderNewFlowInventoryCountEditModalTemplate} from 'themes/application/facility-order-new-flow-inventory/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderNewFlowInventoryCountEditModalStore } from 'application/facility-order-new-flow-inventory/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderNewFlowInventoryCountEditModalStore(rootStore, componentProps), 'facilityOrderNewFlowInventoryCountEditModalStore')
@observer
class FacilityOrderNewFlowInventoryCountEditModal extends React.Component {
    render() {
        return <FacilityOrderNewFlowInventoryCountEditModalTemplate {...this.props} />
    }
}

export default FacilityOrderNewFlowInventoryCountEditModal;
